import React from "react";
import { Dropdown } from "react-bootstrap";
import { Anchor, Button, Icon, Text } from "../elements";
import { useNavigate } from "react-router-dom";

export function QuickActions({ icon, dropdown }) {
  const navigate = useNavigate();

  const handleOnClick = (path) => {
    navigate(path);
  };

  return (
    <Dropdown>
      <Dropdown.Toggle className={`mc-dropdown-toggle mc-header-icon `}>
        <Icon type={icon} />
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" className="mc-dropdown-paper">
        {!dropdown.length ? (
          <Text>No items found</Text>
        ) : (
          dropdown.map((item, index) => (
            <Button key={index} className={"mc-header-language"} onClick={() => handleOnClick(item.path)}>
              <Icon type={item.icon} />
              <Text as="span">{item.text}</Text>
            </Button>
          ))
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
